import isEqual from 'lodash/isEqual'

const getEntityLandingHeaderBackgroundUrl = (entity, isIntegrated) => {
    if (!entity) { return null }

    const IMAGE_LABEL = 'medium'
    let image = (entity.images || []).find(image => image.label?.toLowerCase() === IMAGE_LABEL)
    if (isIntegrated && entity.image) {
        image = {
            image: entity.image + '?dimensions=480x224'
        }
    }

    return (image || {}).image || null
}

const findEntityByQuery = (query, entities = []) => {
    return entities.find(entity => {
        if (!(entity.type === 'city' || entity.type === 'performer' || entity.type === 'venue')) { return false }
        return (entity.name || '').toLowerCase() === query.toLowerCase()
    }) || null
}

const makeEntityRoute = (entityType, entity) => {
    switch (entityType) {
    case 'city':
    case 'cities':
        return {
            name: 'city',
            params: { cityId: entity.id }
        }
    case 'event':
    case 'events':
        return {
            name: entity.isExclusive ? 'exclusive-event' : 'event',
            params: { eventId: entity.id }
        }
    case 'performer':
    case 'performers':
        return {
            name: 'performer',
            params: { performerId: entity.id }
        }
    case 'venue':
    case 'venues':
        return {
            name: 'venue',
            params: { venueId: entity.id }
        }
    default:
        if (entity.name) {
            return {
                name: 'search',
                query: {
                    q: entity.name
                }
            }
        } else {
            return ''
        }
    }
}

const updateRecentSearches = (recentSearches, search) => {
    const duplicateIndex = recentSearches.findIndex(recentSearch => {
        if (search.route.name === 'search' && recentSearch.route.name === 'search') {
            return search.route.query.q === recentSearch.route.query.q
        } else {
            return isEqual(search.route.params, recentSearch.route.params)
        }
    })

    if (duplicateIndex > -1) {
        return [search].concat(recentSearches.slice(0, duplicateIndex), recentSearches.slice(duplicateIndex + 1))
    } else {
        return [search].concat(recentSearches).slice(0, 4)
    }
}

export {
    findEntityByQuery,
    getEntityLandingHeaderBackgroundUrl,
    makeEntityRoute,
    updateRecentSearches
}
